// ANNOUNCEMENT BAR

const announcement = document.querySelector('.announcement');
const dismissAnnouncement = document.querySelector('.announcement-dismiss');

if(announcement) {
  if ( !document.cookie.split(";").some((item) => item.trim().startsWith("sb_announcement_dismissed")) ) {
    announcement.classList.remove('hidden');
  }
  dismissAnnouncement.addEventListener("click", () => {
    const d = new Date();  
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = 'sb_announcement_dismissed=1;' + expires + ';path=/';
    announcement.classList.add('hidden');
  });
}



// AGEGATE

const agegate = document.getElementById("agegate");
const agegateClose = document.getElementById("agegate-button");

if ( !document.cookie.split(";").some((item) => item.trim().startsWith("sb_agegate_dismissed")) ) {  
  agegate.classList.add("is-active");
  document.body.classList.add("agegate-active");
} else {
  agegate.classList.remove("is-active");
  document.body.classList.remove("agegate-active");
}


agegateClose.addEventListener("click", () => {
  agegate.classList.remove("is-active");
  document.body.classList.remove("agegate-active");
  document.cookie = "sb_agegate_dismissed=1; path=/";
});